import { createSlice } from "@reduxjs/toolkit";
import { Dispatch } from "redux";
import axios from "../utils/axios.tsx";

import { ClickedExampleState, Example } from "./types.tsx";

const initialState: ClickedExampleState = {
  text: "",
  exampleItems: [],
};

const clickedExampleSlice = createSlice({
  name: "clickedExample",
  initialState,
  reducers: {
    setText(state, action) {
      state.text = action.payload;
    },
    setExampleItems(state, action) {
      state.exampleItems = action.payload;
    },
  },
});

export const clickedExampleActions = clickedExampleSlice.actions;

export const fetchExamples = ({ isLoggedIn }: { isLoggedIn: boolean }) => {
  return async (dispatch: Dispatch) => {
    const url = isLoggedIn ? "/v1/example/" : "/v1/anonymous/example/";
    const sendRequest = async () => {
      const response = await axios.get(url);
      if (response.status !== 200) {
        console.log("Error fetching examples");
      } else {
        const examples = response.data.objects.map(
          (example: Example) => example.text,
        );
        dispatch(clickedExampleActions.setExampleItems(examples));
      }
    };
    try {
      await sendRequest();
    } catch (error) {
      console.error("Error fetching examples:", error);
    }
  };
};

export default clickedExampleSlice.reducer;
